var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SiruiSearch',{ref:"baseInfoFormRef",attrs:{"query":_vm.baseFormData,"columns":_vm.formColumn,"isQueryPanel":false,"rules":_vm.formRules,"isDisabledForm":_vm.isDisabledForm},on:{"changeMethod":_vm.changeMethod}})
}
var staticRenderFns = []

export { render, staticRenderFns }